<template>
  <div class="mt-4 grid grid-cols-3 grid-rows-1 gap-4">
    <LabeledText :label="t('rentalPartner')">{{
      t(`rentalPartners.${allocation.rentalPartner}`)
    }}</LabeledText>

    <LabeledText :label="t('referenceNumber')">{{ allocation.comment }}</LabeledText>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import LabeledText from '@/components/LabeledText.vue';
import type { Allocation } from '@/entities/allocations/allocation.entity.ts';

const { t } = useI18n();
defineProps<{
  allocation: Allocation;
}>();
</script>

<i18n lang="json">
{
  "en": {
    "rentalPartner": "Rental Partner",
    "referenceNumber": "Reference Number"
  },
  "de": {
    "rentalPartner": "Mietpartner",
    "referenceNumber": "Referenznummer"
  },
  "es": {
    "rentalPartner": "Partner de alquiler",
    "referenceNumber": "Número de referencia"
  }
}
</i18n>
